function getSuppressedActiveBlocks(currentBlock) {
	return Array.from(
		document.querySelectorAll(
			'.wp-block-gfd-line-reveal-header-block.is-state-active[data-suppress-active-on-sibling-hover="true"]'
		)
	).filter((block) => block !== currentBlock);
}

function suppressSiblingActiveStates(currentBlock) {
	getSuppressedActiveBlocks(currentBlock).forEach((block) => {
		if (
			block.getAttribute(
				'data-never-return-to-active-after-sibling-hover'
			) === 'true'
		) {
			block.classList.add('is-state-active-disabled');
			block.classList.remove('is-state-active-suppressed');
			return;
		}

		block.classList.add('is-state-active-suppressed');
	});
}

function restoreSiblingActiveStates() {
	document
		.querySelectorAll(
			'.wp-block-gfd-line-reveal-header-block.is-state-active-suppressed'
		)
		.forEach((block) => {
			block.classList.remove('is-state-active-suppressed');
		});
}

document
	.querySelectorAll('.wp-block-gfd-line-reveal-header-block')
	.forEach((block) => {
		block.addEventListener('mouseenter', () => {
			suppressSiblingActiveStates(block);
		});

		block.addEventListener('mouseleave', () => {
			restoreSiblingActiveStates();
		});
	});
